module.exports = __webpack_public_path__ + "img/375_leuco_intro_img1.141b3741.png";